module.exports = __webpack_public_path__ + "static/Cel1Esp-1755f097d9f419fc801d8d5c3e3caf6e.mp4";